// extracted by mini-css-extract-plugin
module.exports = {"button":"e_qj","inner":"e_rj","innerText":"e_sj"};